import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../helpers/reducerRegistry'
import { getQuickAssessmentCorporateThunk } from './thunk'

const initialState = {
  loading: true,
  overallAssessment: [],
  indicators: [],
}

const slice = createSlice({
  name: 'companyAnalysis/financialAnalysis/corporate/quickAssessment',
  initialState: initialState,
  reducers: {
    resetStoreQuickAssessmentCorporate(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getQuickAssessmentCorporateThunk.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      getQuickAssessmentCorporateThunk.fulfilled,
      (state, action) => {
        Object.keys(action.payload || {}).forEach((key) => {
          state[key] = action.payload[key]
        })
        state.loading = false
      },
    )
    builder.addCase(getQuickAssessmentCorporateThunk.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { resetStoreQuickAssessmentCorporate } = slice.actions

export const selectLoading = (state) => state[slice.name].loading

export const selectOverallAssessment = (state) =>
  state[slice.name].overallAssessment

export const selectIndicators = (state) => state[slice.name].indicators

register(slice.name, slice.reducer)
